<ion-item
  lines="none"
  class="send-message-item"
  [disabled]="isDisabled"
>

  <yu-button
    class="file-button"
    type="clear"
    color="gradient"
    (yuClick)="fileUpload.click()"
  >
    <yu-icon name="paperclip"></yu-icon>
  </yu-button>

  <yu-input
    class="message-input"
    [placeholder]="'ITEMS.CHATS.LEAVE_COMMENT' | translate"
    autocapitalize="sentences"
    [(value)]="message"
  ></yu-input>

  <yu-button
    type="solid"
    color="gradient"
    (yuClick)="sendMessageAction()"
  >
    <yu-icon name="paper-plane-right"></yu-icon>
  </yu-button>

</ion-item>

<input [hidden]='true' type="file" (change)="attachFileAction($event)" #fileUpload>
